import {
  isDataGrailInitialized,
  showConsentPreferences,
} from '@linktr.ee/cookie-consent';
import { useState } from 'react';
import { isMobileApp } from '../utils/isMobileApp';
import { reportClientError } from '../utils/reportClientError';

const waitForDataGrail = (
  resolve: () => void,
  reject: (error: Error) => void,
  maxAttempts: number = 50,
  attempt: number = 0
): void => {
  if (isDataGrailInitialized()) {
    resolve();
    return;
  }

  if (attempt >= maxAttempts) {
    reject(new Error('DataGrail failed to initialize after 5 seconds'));
    return;
  }

  setTimeout(
    () => waitForDataGrail(resolve, reject, maxAttempts, attempt + 1),
    100
  );
};

const loadDataGrailScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (isDataGrailInitialized()) {
      resolve();
      return;
    }

    waitForDataGrail(resolve, reject);
  });
};

export const CookiePrefs = () => {
  const [isLoading, setIsLoading] = useState(false);

  // Hide cookie preferences in mobile app
  if (isMobileApp()) {
    return null;
  }

  const handleClick = async () => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      await loadDataGrailScript();
      showConsentPreferences();
    } catch (error) {
      reportClientError('Failed to load DataGrail', error, {
        source: 'cookie-preferences',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '12px',
        left: '12px',
        zIndex: 100,
        display: 'flex',
        height: 'auto',
        width: 'auto',
        flexDirection: 'row',
        justifyContent: 'flex-start',
      }}
      data-testid="cookie-preferences-container"
      data-nosnippet
    >
      <button
        id="cookie-preferences-button"
        type="button"
        color="inherit"
        className="text-caption-medium-medium"
        onClick={handleClick}
        disabled={isLoading}
      >
        {isLoading ? 'Loading...' : 'Cookie preferences'}
      </button>
    </div>
  );
};
